export { default } from './LlegendaAnysComparacio';
